import { UsersAPI } from "./routers/users";
import { ProagricaAPI } from "./routers/proagrica";
import { AgrianAPI } from "./routers/agrian";
import { StandardAxiosConfig } from "./common";
import { apiClient } from "./client";
import {
	BarcodeTypesAPI,
	BranchesAPI,
	CompaniesAPI,
	ContactsAPI,
	DealsAPI,
	DropoffsAPI,
	GrowersAPI,
	JobsAPI,
	JobsReadyAPI,
	LabTestsAPI,
	RegionsAPI,
	RobotsAPI,
	ShiftsAPI,
	TeamMembersAPI,
} from "./routers/data/tables";
import { MissionControlAPI } from "./routers/mission-control";
import { MissionsAPI } from "./routers/missions";
import { LabelsAPI } from "./routers/labels";
import { WeatherAPI } from "./routers/weather";
import { env } from "../config/env";

export namespace API {
	export const Users = new UsersAPI();
	export const MissionControl = new MissionControlAPI();
	export const Missions = new MissionsAPI();
	export const Labels = new LabelsAPI();
	export const Weather = new WeatherAPI();
	export namespace Integrations {
		export const Proagrica = new ProagricaAPI();
		export const Agrian = new AgrianAPI();
	}
	export namespace Data {
		export async function clearCache() {
			await apiClient.get(`${env.rogoApiUrl}/cache/clear`, StandardAxiosConfig());
			await apiClient.get(`${env.rogoApiUrl}/proagrica/cache/clear`, StandardAxiosConfig());
			await apiClient.get(`${env.rogoApiUrl}/agrian/cache/clear`, StandardAxiosConfig());
		}
		export const Contacts = new ContactsAPI();
		export const Jobs = new JobsAPI();
		export const Deals = new DealsAPI();
		export const Companies = new CompaniesAPI();
		export const Growers = new GrowersAPI();
		export const Branches = new BranchesAPI();
		export const Regions = new RegionsAPI();
		export const JobsReady = new JobsReadyAPI();
		export const TeamMembers = new TeamMembersAPI();
		export const Robots = new RobotsAPI();
		export const Shifts = new ShiftsAPI();
		export const LabTests = new LabTestsAPI();
		export const BarcodeTypes = new BarcodeTypesAPI();
		export const Dropoffs = new DropoffsAPI();
	}
}
